export default __webpack_public_path__ + "images/happy.f950c5833ddb9fb676063f295bdf5a52.svg";